import {
    logo,
    positivElevBig,
    clockOClockBig,
    mapBig,
    paceBig,
    pdfHeaderImg,
  } from "../../assets/encoded-bg-img";

export const MobileSplitsHeader = (pdf, activityDetails, summaryUnitLabels) => {
  const {
      totalDistanceRounded,
      totalPositiveElevationRounded,
      paceTime,
      activityTime,
    } = activityDetails;
  
  pdf.addImage(pdfHeaderImg, 0, 0, pdf.internal.pageSize.getWidth(), 350);
  pdf.addImage(logo, 10, 6, 37*4, 9*4);
  let linkText = `www.waldup.com`;
  pdf.setTextColor("#014d72");
  pdf.setFontSize(30);
  pdf.text(linkText, 300, 30, "center");
  pdf.setFontSize(90);
  pdf.setTextColor("#003d73");
  // let totalNegElev = `${totalNegativeElevationRounded} ${summaryUnitLabels[2]}`;
  pdf.setFont('OpenSans-Bold','bold');
  pdf.text(activityDetails.title, 10, 120);
  pdf.setTextColor("#000000")

  let totaldist = `${totalDistanceRounded} ${summaryUnitLabels[1]}`;
  let totalPosElev = `${totalPositiveElevationRounded} ${summaryUnitLabels[2]}`;

  pdf.setFontSize(72);
  // line 1
  const yLine1 = 180;
  const yLineTextOffset = 45;
  pdf.addImage(mapBig, 10, yLine1, 50, 50);
  pdf.text(totaldist, 80, yLine1 + yLineTextOffset);
  pdf.addImage(positivElevBig, 340, yLine1, 60, 60); 
  pdf.text(totalPosElev, 400, yLine1 + yLineTextOffset);

  // line 2
  const yLine2 = 280
  pdf.addImage(clockOClockBig, 10, yLine2, 50, 50);
  pdf.text(activityTime, 80, yLine2 + yLineTextOffset);
  pdf.addImage(paceBig, 340, yLine2, 50, 50);
  pdf.text(`${paceTime} ${summaryUnitLabels[0]}`, 400, yLine2 + yLineTextOffset);
  pdf.setFont('OpenSans-Regular','normal');
  };
